import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { useAppSelector } from "../../../app/hooks";
import {
  createBetAsync,
  getWagerAsync,
  resolveWagerAsync,
} from "../bettingSlice";
import { BetCreation } from "../types";
import BetCreationModal from "./BetCreationModal";
import ResolveWagerModal from "./ResolveWagerModal";
import WagerOutcomes from "./WagerOutcomes";

export default function WagerView() {
  const dispatch = useDispatch();
  let { wagerId } = useParams();
  const [displayBetModal, setDisplayBetModal] = useState(false);
  const [displayResolveWagerModal, setDisplayResolveWagerModal] =
    useState(false);

  const wager = useAppSelector((state) => state.betting.wager);
  const userId = useAppSelector((state) => state.auth.user)?.profile?.sub;

  useEffect(() => {
    dispatch(getWagerAsync(wagerId));
  }, []);

  if (!wager) return <div>{wagerId}</div>; // TODO: Display loading or something instead

  const placeBet = (bet: BetCreation) => {
    setDisplayBetModal(false);
    dispatch(createBetAsync(bet));
  };

  const resolveWager = (outcome: number) => {
    setDisplayResolveWagerModal(false);
    dispatch(
      resolveWagerAsync({
        wagerId,
        outcome,
      })
    );
  };

  return (
    <>
      <Card className="p-3 mt-3">
        <Card.Body>
          <Card.Title>
            <h3>{wager.title}</h3>
          </Card.Title>
          <Card.Text>
            <h4>Bets placed</h4>
            <p>{wager.bets.length}</p>
            <h4>Outcomes</h4>
            <WagerOutcomes wager={wager} />
          </Card.Text>
          {wager.finalOutcome == null ? (
            <>
              <Button onClick={() => setDisplayBetModal(true)}>
                Place Bet
              </Button>
              <Button
                onClick={() => setDisplayResolveWagerModal(true)}
                disabled={userId !== wager.creatorId}
                className="mx-2"
              >
                Resolve Wager
              </Button>
            </>
          ) : (
            <>
              <h4>Final Outcome</h4>
              <p>{wager.outcomes[wager.finalOutcome]}</p>
            </>
          )}
        </Card.Body>
      </Card>
      <BetCreationModal
        wager={wager}
        show={displayBetModal}
        onSubmit={placeBet}
        onClose={() => setDisplayBetModal(false)}
      />
      <ResolveWagerModal
        wager={wager}
        show={displayResolveWagerModal}
        onSubmit={resolveWager}
        onClose={() => setDisplayResolveWagerModal(false)}
      />
    </>
  );
}
